"use client";

import { VaulModal } from "@repo/ui";
import Image from "next/image";
import xcloseIcon from "public/icons/XCloseIcon.svg";
import { Drawer } from "vaul";
import Content from "./content";

interface MenuModalProps {
  isOpen: boolean;
  onClose: () => void;
  hasSubscription: boolean;
  onSeePlans: () => void;
}

export const MenuModal: React.FC<MenuModalProps> = ({
  isOpen,
  onClose,
  hasSubscription,
  onSeePlans,
}) => {
  return (
    <VaulModal isOpen={isOpen} onClose={onClose} dismissible={true}>
      <Drawer.Title className="sr-only">More options</Drawer.Title>
      <Drawer.Description className="sr-only">
        Additional menu options and settings
      </Drawer.Description>

      <div className="relative">
        <button
          onClick={onClose}
          aria-label="Close menu"
          className="absolute top-4 right-4 p-2 text-foreground-muted hover:text-foreground transition-colors z-10"
        >
          <Image
            src={xcloseIcon}
            alt="Close"
            height={18}
            width={18}
            unoptimized
          />
        </button>
        <Content
          headerText={"More"}
          className="px-[24px] pt-[24px]"
          onClose={onClose}
          hasSubscription={hasSubscription}
          onSeePlans={onSeePlans}
        />
        <div className="w-full h-[22px]" />
      </div>
    </VaulModal>
  );
};
